import React from 'react'
import AvatarWrapper from 'ui/partials/AvatarWrapper'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import { WhenModelValue } from '@morningtrain/react-resources'
import { Can } from '@morningtrain/react-auth'

export default function ShiftSmartviewProfileView () {
  return (
    <div className='space-y-2'>
      <div className='flex items-center'>
        <AvatarWrapper large>
          <Displays.Image name='user.avatar_url' />
        </AvatarWrapper>
        <div className='mr-6'>
          <div className='font-medium text-base leading-tight'>
            <Displays.Text name='user.name' />
          </div>
          <div className='text-sm text-gray-500 leading-tight'>
            <Displays.Text name='user.employment_name' />
          </div>
        </div>
      </div>

      <UI.DisplayWithTitle title={<Translation name='fields.phone.label' />}>
        <Displays.Phone name='user.phone' />
      </UI.DisplayWithTitle>

      <UI.DisplayWithTitle title={<Translation name='fields.email.label' />}>
        <Displays.Email name='user.email' />
      </UI.DisplayWithTitle>

      <Can permission='shifts.view_all_areas'>
        <UI.SpaceBetween>
          <UI.DisplayWithTitle title={<Translation name='shifts.partials.shifts_count' />}>
            <Displays.Integer name='user.shifts_count' />
          </UI.DisplayWithTitle>
          <UI.DisplayWithTitle title={<Translation name='smartviews.user_salary_overview.planned_shifts' />}>
            <Displays.Integer name='user.planned_hours' />
            <WhenModelValue name='user.expected_hours'>
              <span> / </span>
              <Displays.Integer name='user.expected_hours' />
            </WhenModelValue>
          </UI.DisplayWithTitle>
        </UI.SpaceBetween>

        <UI.DisplayWithTitle title={<Translation name='fields.salary_type.label' />}>
          <Displays.Enum name='user.salary_type' enum='salary_type' />
        </UI.DisplayWithTitle>
      </Can>

    </div>
  )
}
